import { render, staticRenderFns } from "./EventProfile.vue?vue&type=template&id=4a8f9888&scoped=true&"
import script from "./EventProfile.vue?vue&type=script&lang=js&"
export * from "./EventProfile.vue?vue&type=script&lang=js&"
import style0 from "./EventProfile.vue?vue&type=style&index=0&id=4a8f9888&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8f9888",
  null
  
)

export default component.exports